// The newest star day this device has already celebrated, per kid. A star a grown-up awards on
// their phone reaches the kid's own device as a newer day here, so Rewards celebrates it once.

const key = (kidId: string) => `pointz.lastStar:${kidId}`;

/** The day last celebrated, "" if none yet, or null when storage is blocked (celebrate nothing). */
export function celebratedStarDay(kidId: string): string | null {
  try {
    return localStorage.getItem(key(kidId)) ?? "";
  } catch {
    return null;
  }
}

/** Records `day` as celebrated, unless a later one already is (day keys sort as dates). */
export function markStarCelebrated(kidId: string, day: string): void {
  try {
    const seen = localStorage.getItem(key(kidId)) ?? "";
    if (day > seen) localStorage.setItem(key(kidId), day);
  } catch {
    /* storage blocked: nothing to remember */
  }
}
